import { COMMENTARY_POSITION, COURT_SEASON_CODES, getSportCourtFields } from '../../lib/utils/sportCourtConfigs';

import BasketballGround from '../../components/Sports/Courts/BasketballCourt/Court'
// court Images
import purcell_pavilion_arena from '../../assets/images/purcell_pavilion_arena.png';
// ball Images
import basketballImage from '../../assets/svgs/basketball.svg';

// check if sport season id is valid or not
export const getSportCourt = (seasonCode) => {
    const Court = getSportCourtFields({ COURT_SEASON_CODES, COURT_CODE: seasonCode })?.court;

    if(Court){
        return Court;
    }else {
        return BasketballGround;
    }
}

export const getSportCourtImage = (seasonCode) => {
    const SportToCourtImage = getSportCourtFields({ COURT_SEASON_CODES, COURT_CODE: seasonCode })?.courtBgImage;

    if(SportToCourtImage){
        return SportToCourtImage;
    }else {
        return purcell_pavilion_arena;
    }
}

export const getSportBallImage = (seasonCode) => {
    const sportBallImage = getSportCourtFields({ COURT_SEASON_CODES, COURT_CODE: seasonCode })?.sportBallImage;

    if(sportBallImage){
        return sportBallImage;
    }else {
        return basketballImage;
    }
}

export const getCommentaryPosition = (zone, seasonCode) => {
    const commentaryPosition = getSportCourtFields({ COURT_SEASON_CODES, COURT_CODE: seasonCode })?.commentaryPosition;    

    if(commentaryPosition){
        return commentaryPosition(zone);
    }else {
        return COMMENTARY_POSITION.PRIMARY;
    }
}